import { Collapse } from 'antd';
import styled from 'styled-components';

export const StyledCollapse = styled(Collapse)`
  width: 100%;
  border-radius: 16px;
  border: 1px solid ${({ theme }) => theme.colors.black4};
  background: ${({ theme }) => theme.colors.white};
  overflow: hidden;

  &.ant-collapse {
    border-radius: 16px;
    border: 1px solid ${({ theme }) => theme.colors.black4};
    background: ${({ theme }) => theme.colors.white};
  }

  .ant-collapse-item {
    border: none;
    border-radius: 16px;
  }

  .ant-collapse-item:last-child {
    border-bottom: none;
    border-radius: 16px;
  }

  .ant-collapse-header {
    padding: 24px !important;
    background: ${({ theme }) => theme.colors.white};
    align-items: center !important;
    border-bottom: none !important;
    border-radius: 16px 16px 0 0;
  }

  .ant-collapse-content {
    border-top: none !important;
    background: ${({ theme }) => theme.colors.white};
  }

  .ant-collapse-content-box {
    padding: 0 24px 24px 24px !important;
  }

  .ant-collapse-expand-icon {
    padding-inline-end: 0 !important;
    color: ${({ theme }) => theme.colors.black8};
  }
`;

export const CollapseHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
`;

export const HeaderLeft = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
`;

export const HeaderTitle = styled.span`
  font-size: 16px;
  font-weight: 500;
  line-height: 24px;
  color: ${({ theme }) => theme.colors.black8};
`;

export const FormContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
  width: 100%;
`;

export const RequirementsSection = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  width: 100%;
`;

export const RequirementsContent = styled.div`
  font-size: 14px;
  font-weight: 400;
  line-height: 20px;
  color: ${({ theme }) => theme.colors.black6};
  width: 100%;

  ul {
    margin: 0;
    padding-left: 20px;
  }

  li {
    margin-bottom: 4px;
  }
`;

export const FormFooter = styled.div`
  display: flex;
  justify-content: flex-end;
  padding-top: 4px;
  width: 100%;
`;
